// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sVQB","content":"styles_content__2K_tU","row":"styles_row__101yr","footer":"styles_footer__9BEkl","phraseLength":"styles_phraseLength__3o4Mn"};